import { ListenerRegister } from '../delta/ListenerRegister'
import { ListenerTrigger } from '../delta/ListenerTrigger'

class Listener {

    private listenerRegisterIndexedById: { [id: string]: ListenerRegister };
    private listenerRegisterIndexedByName: { [name: string]: string[] };

    constructor() {
        this.listenerRegisterIndexedById = {};
        this.listenerRegisterIndexedByName = {};
    }

    public clear() {
        this.listenerRegisterIndexedById = {};
        this.listenerRegisterIndexedByName = {};
    }

    public register(listenerRegister: ListenerRegister) {
        if (this.listenerIsAlreadyRegistered(listenerRegister.id)) {
            throw new Error(`id [${listenerRegister.id}] was already registered by [${this.getListenerRegisterById(listenerRegister.id).name}]`);
        }
        this.listenerRegisterIndexedById[listenerRegister.id] = listenerRegister;
        this.listenerRegisterIndexedByName[listenerRegister.name] = this.listenerRegisterIndexedByName[listenerRegister.name] ? this.listenerRegisterIndexedByName[listenerRegister.name].concat([listenerRegister.id]) : [listenerRegister.id];
    }

    public registers(listenerRegisters: ListenerRegister[]) {
        listenerRegisters.forEach(listenerRegister => this.register(listenerRegister));
    }

    public unregister(listenerRegister: ListenerRegister) {
        listenerRegister = this.getListenerRegisterById(listenerRegister.id);
        if (listenerRegister !== undefined) {
            delete this.listenerRegisterIndexedById[listenerRegister.id];
            if (this.listenerRegisterIndexedByName[listenerRegister.name]) {
                const index = this.listenerRegisterIndexedByName[listenerRegister.name].indexOf(listenerRegister.id);
                this.listenerRegisterIndexedByName[listenerRegister.name].splice(index, 1);
            }
        }
    }

    public unregisters(listenerRegisters: ListenerRegister[]) {
        listenerRegisters.forEach(listenerRegister => this.unregister(listenerRegister));
    }

    public trigger(listenerTrigger: ListenerTrigger) {
        if (!listenerTrigger.id) throw new Error(`listenerTrigger.id is mandatory and can not be falsy`);
        const listenerRegister = this.getListenerRegisterById(listenerTrigger.id);
        if (listenerRegister === undefined) throw new Error(`no listener is registered with id ${listenerTrigger.id}`);
        listenerRegister.callback(listenerTrigger.payload);
    }

    public triggers(listenerTriggers: ListenerTrigger[]) {
        listenerTriggers.forEach(listenerTrigger => this.trigger(listenerTrigger));
    }

    public triggerByName(listenerTrigger: ListenerTrigger) {
        if (!listenerTrigger.name) throw new Error(`listenerTrigger.name is mandatory and can not be falsy`);
        if (listenerTrigger.id) console.warn(`you should provide a falsy listenerTrigger.id cause it will be ignored`);
        const listenerTriggerIds = this.listenerRegisterIndexedByName[listenerTrigger.name] || [];
        listenerTriggerIds.forEach(listenerTriggerId => {
            listenerTrigger.id = listenerTriggerId;
            this.trigger(listenerTrigger);
        });
    }

    private getListenerRegisterById(id: string): ListenerRegister {
        return this.listenerRegisterIndexedById[id];
    }

    private listenerIsAlreadyRegistered(id: string) {
        return this.listenerRegisterIndexedById[id] !== undefined;
    }
}

export default Listener;
